'use client';

import { updateCartQuantity } from '@/lib/redux/features/cart';
import { useAppDispatch } from '@/lib/redux/hooks';
import { useState } from 'react';

interface CartQuantityProps {
  productId: string;
  currentQuantity: number;
  size?: string;
  forParentQuantity?: any;
}

const CartQuantity: React.FC<CartQuantityProps> = ({
  productId,
  currentQuantity,
  size = '',
  forParentQuantity,
}) => {
  const dispatch = useAppDispatch();
  const [quantity, setQuantity] = useState(currentQuantity);

  const handleDecrease = () => {
    if (quantity > 1) {
      const newQty = quantity - 1;
      setQuantity(newQty);
      forParentQuantity(newQty);
      dispatch(updateCartQuantity({ id: productId, quantity: newQty })); 
    
    }
  };

  const handleIncrease = () => {
    const newQty = quantity + 1;
    setQuantity(newQty);
    forParentQuantity(newQty);
    dispatch(updateCartQuantity({ id: productId, quantity: newQty }));
   
  };

  return (
    <div className="quantity-button">
      <button
        className={`quantity-button__control quantity-button__control--decrease ${size}`}
        onClick={handleDecrease}
      >
        -
      </button>
      <span className={`quantity-button__display ${size}`}>{quantity}</span>
      <button
        className={`quantity-button__control quantity-button__control--increase ${size}`}
        onClick={handleIncrease}
      >
        +
      </button>
    </div>
  );
};

export default CartQuantity;
